import React from "react";
import { Breadcrumbs, Typography, Link } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";

function BreadcrumbNavigation({
  breadcrumbItems,
  activeIndex,
  onBreadcrumbClick,
}) {
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator={
        <svg
          style={{ verticalAlign: "middle" }}
          width="20"
          height="20"
          fill="currentColor"
          aria-hidden="true"
          viewBox="0 0 24 24"
        >
          <path d="M9.29 6.71c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41l5 5-5 5c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0l5.71-5.71c.39-.39.39-1.02 0-1.41l-5.71-5.71z" />
        </svg>
      }
      marginBottom="30px"
    >
      {breadcrumbItems.map((item, idx) => {
        if (!item.show) return null;

        let color = "#9FA6AD";
        if (idx < activeIndex) color = "#9FA6AD";
        if (idx === activeIndex) color = "#0B6BCB";

        if (idx === breadcrumbItems.length - 1 || idx === activeIndex) {
          return (
            <Typography
              color={color}
              key={item.key}
              sx={{
                display: "flex",
                alignItems: "center",
                fontWeight: 400,
                fontSize: 14,
              }}
            >
              {item.label}
            </Typography>
          );
        }
        return (
          <Link
            underline="none"
            color={color}
            href="#"
            key={item.key}
            onClick={() => onBreadcrumbClick(idx)}
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: 400,
              fontSize: 14,
              cursor: "pointer",
              "&:hover": { color: "#0B6BCB", textDecoration: "underline" },
            }}
          >
            {item.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}

export default BreadcrumbNavigation;
